import { User } from 'model/User';
import { WorkResource } from 'model/WorkResource';

export const convertDateFormat = {
  basic: (y: number, m: number, d: number) => `${y}/${(m + 1).toString().padStart(2, '0')}/${d.toString().padStart(2, '0')}`,
  list: (_y: number, m: number, d: number) => `${m + 1}月${d}日`,
};

export const convertTimestamp = (input: number) =>
  input * (input > 1000000000000 ? 1 : 1000);

export const convertDate = (
  input: Date | number | null | undefined,
  format: keyof typeof convertDateFormat = 'basic'
) => {
  if (!input) {
    return 'ー';
  }

  const date = typeof input === 'object'
    ? input
    : new Date(convertTimestamp(input));

  return convertDateFormat[format](
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );
};

export const convertDateCode = (input: Date | number) =>
  (
    (date) => date.getFullYear() * 10000 + (date.getMonth() + 1) * 100 + date.getDate()
  )(
    typeof input === 'object' ? input : new Date(convertTimestamp(input))
  );

export const convertTime = (input: Date | number) =>
  (
    (date) => ((h, m) => `${h}:${m}`)(
        date.getHours().toString().padStart(2, '0'),
        date.getMinutes().toString().padStart(2, '0')
    )
  )(
    typeof input === 'object' ? input : new Date(convertTimestamp(input))
  );

export const convertUserName = (user: Partial<User>) =>
  (user.firstName && user.lastName) ? (
    user.nameNotationType === 'western' ?
      `${user.firstName}・${user.lastName}` :
    user.nameNotationType === 'point' ?
      `${user.lastName}・${user.firstName}` :
      `${user.lastName} ${user.firstName}`
  ) : (
    user.firstName || user.lastName || ''
  );

export const convertCosts = (costs?: { type: WorkResource['type'] | 'user' | 'partner', cost: number }[]) => {
  const totalCosts = { personal: 0, macinery: 0, industrialWaste: 0, other: 0, total: 0 };
    (costs || []).forEach(({ type, cost }) => {
      switch (type) {
        case 'user':
        case 'partner':
        case 'person':
          totalCosts.personal += cost;
          break;
        case 'machinery':
        case 'att':
        case 'tool':
          totalCosts.macinery += cost;
          break;
        case 'industrial_waste':
          totalCosts.industrialWaste += cost;
          break;
        default:
          totalCosts.other += cost;
      }
      totalCosts.total += cost;
    });

    return totalCosts;
};
